import { useState } from "react";
import { ChevronDown, Pencil, X } from "lucide-react";
import { cn } from "@/lib/cn";
import { IconeColorido } from "@/components/comecar/selecao/IconeColorido";
import { iconeDaCategoria } from "@/components/comecar/selecao/icones-da-selecao";

type Especialidade = { id: string; label: string; procedimentos: { id: string; nome: string }[] };

/** Uma especialidade da clínica: quantos procedimentos ela tem; abre a lista, com "Editar". */
export function CartaoDaEspecialidade({
  especialidade: e,
  podeEditar,
  onEditar,
  onRemover,
}: {
  especialidade: Especialidade;
  podeEditar: boolean;
  onEditar: () => void;
  onRemover: () => void;
}) {
  const [aberto, setAberto] = useState(false);
  const n = e.procedimentos.length;
  return (
    <div className="self-start rounded-lg border border-zinc-200 bg-white shadow-sm dark:border-border dark:bg-card">
      <div className="flex items-center gap-2 px-3.5 py-3">
        <button type="button" onClick={() => setAberto((v) => !v)} aria-expanded={aberto} className="flex min-w-0 flex-1 items-center gap-2 text-left">
          <ChevronDown className={cn("h-4 w-4 shrink-0 text-zinc-400 transition-transform", !aberto && "-rotate-90")} />
          {/* O mesmo ícone do criar organização e do cadastro inicial. */}
          <IconeColorido {...iconeDaCategoria(e.label)} tamanho="md" />
          <span className="min-w-0">
            <span className="block truncate text-sm font-semibold text-zinc-900 dark:text-foreground">{e.label}</span>
            <span className="block text-xs text-zinc-500 dark:text-muted-foreground">
              {n} {n === 1 ? "procedimento" : "procedimentos"}
            </span>
          </span>
        </button>
        {podeEditar && (
          <button
            type="button"
            onClick={onRemover}
            aria-label={`Remover ${e.label}`}
            className="rounded p-1 text-zinc-400 hover:bg-zinc-100 hover:text-zinc-600 dark:hover:bg-muted"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
      {aberto && (
        <div className="border-t border-zinc-100 px-3.5 py-3 dark:border-border">
          {n === 0 ? (
            <p className="text-xs text-zinc-500 dark:text-muted-foreground">Nenhum procedimento desta especialidade na clínica.</p>
          ) : (
            <ul className="space-y-1 text-[13px] text-zinc-700 dark:text-foreground/90">
              {e.procedimentos.map((p) => (
                <li key={p.id}>{p.nome}</li>
              ))}
            </ul>
          )}
          {podeEditar && (
            <button
              type="button"
              onClick={onEditar}
              className="mt-3 inline-flex h-8 items-center gap-1.5 rounded-md border border-zinc-200 px-3 text-xs font-semibold text-zinc-700 hover:bg-zinc-50 dark:border-border dark:text-foreground dark:hover:bg-muted"
            >
              <Pencil className="h-3.5 w-3.5" />
              Editar
            </button>
          )}
        </div>
      )}
    </div>
  );
}
